(function () {
  function init() {
    var box = document.getElementById('size-guide-box');
    if (!box) return;

    // Scope lookups to the enclosing <product-info> so we never grab an
    // unrelated fieldset from something like a quick-add modal elsewhere
    // on the page.
    var productInfo = box.closest('product-info') || document;

    function attach() {
      var fieldset = productInfo.querySelector('fieldset.product-form__input');
      if (!fieldset) return;
      var variantSelects = fieldset.closest('variant-selects');
      if (!variantSelects) return;

      // Shopify replaces the entire <variant-selects> element with a freshly
      // server-rendered copy every time the customer changes an option (see
      // ProductInfo.updateOptionValues in product-info.js). That fresh copy
      // is a plain, unwrapped fieldset - it doesn't know this box exists.
      // Drop whatever stale fieldset is still sitting in the box from the
      // previous render before adopting the new one.
      Array.prototype.forEach.call(box.querySelectorAll('fieldset.product-form__input'), function (old) {
        if (old !== fieldset) old.remove();
      });

      if (!box.contains(fieldset)) {
        box.appendChild(fieldset);
      }
      // Keep the box itself inside <variant-selects> so the theme's
      // built-in change listener (bound directly on <variant-selects>)
      // still fires when a size is clicked. Re-parent on every update
      // since the swap above targets a brand new <variant-selects> node.
      if (box.parentNode !== variantSelects) {
        variantSelects.appendChild(box);
      }

      // Dawn's own AJAX update (HTMLUpdateUtility.viewTransition) walks the
      // outgoing <variant-selects> and suffixes every id it finds with a
      // timestamp, to avoid collisions while the old and new copies briefly
      // coexist. Since this box lives inside variant-selects, its id (and
      // the size-guide link's id) get caught by that too - which silently
      // breaks every #size-guide-box CSS rule (the picker falls back to
      // plain default button styling) even though the box is still
      // correctly attached. Restore the real id every time.
      box.id = 'size-guide-box';
      var linkEl = box.querySelector('.size-guide-box__link');
      if (linkEl) linkEl.id = 'size-guide-link';
    }

    attach();

    var warning = document.getElementById('size-select-warning');
    function updateWarning() {
      if (!warning) return;
      var hasSelection = !!box.querySelector('input[type="radio"]:checked');
      warning.classList.toggle('is-visible', !hasSelection);
    }
    box.addEventListener('change', updateWarning);
    updateWarning();

    if (!box.dataset.linkBound) {
      box.dataset.linkBound = '1';
      var link = document.getElementById('size-guide-link');
      if (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var target = null;
          document.querySelectorAll('details').forEach(function (d) {
            var summary = d.querySelector('summary');
            if (summary && /size chart/i.test(summary.textContent)) {
              target = d;
            }
          });
          if (target) {
            target.setAttribute('open', '');
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }

    // Re-run the attach step after every variant/option change, not just
    // once on page load - this is the actual fix. Without it, the box
    // survives exactly one size change before the AJAX-swapped picker
    // falls back outside it.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !box.dataset.resubscribed) {
      box.dataset.resubscribed = '1';
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        attach();
        updateWarning();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
